import { render } from "./HistorialVentas.vue?vue&type=template&id=2983c1ae"
import script from "./HistorialVentas.vue?vue&type=script&lang=js"
export * from "./HistorialVentas.vue?vue&type=script&lang=js"

import "./HistorialVentas.vue?vue&type=style&index=0&id=2983c1ae&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__